/**
 * @generated SignedSource<<da4cc3657e52d672d502715624d2e26d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedMobileRelatedItem_item$data = {
  readonly isFurniture: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_item" | "FavoritesItem_item" | "ItemTile_item" | "SharedFavoriteItem_item" | "useFavoritesItem_item">;
  readonly " $fragmentType": "SharedMobileRelatedItem_item";
};
export type SharedMobileRelatedItem_item$key = {
  readonly " $data"?: SharedMobileRelatedItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileRelatedItem_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v1 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedMobileRelatedItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFurniture",
      "storageKey": null
    },
    {
      "args": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "ItemTile_item"
    },
    {
      "args": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "Literal",
          "name": "showSeller",
          "value": false
        }
      ],
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFavoriteItem_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "fd3daf8f350067c272330cf8ba34d2ea";

export default node;
